<section>
  <h2>Données statistiques d'utilisation</h2>
  <p>Mise à jour le {{today | date:'mediumDate'}}</p>

  <mat-divider></mat-divider>

  <h1>Vos appareils</h1>
  <!-- **** Sélection du device **** -->
  <div>
    <ng-container *ngIf="!selectedDevice">
      <button class="btn-select-device" mat-stroked-button [matMenuTriggerFor]="menu">
        Tous les appareils <mat-icon>expand_more</mat-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="selectedDevice">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        {{ selectedDevice.name }} <mat-icon>expand_more</mat-icon>
      </button>
    </ng-container>

    <mat-menu #menu="matMenu">

      <button mat-menu-item
              (click)="changeSelectedDevice('global')">
        <p>Tous les appareils</p>
      </button>
      <button (click)="changeSelectedDevice(device.deviceName)"
              *ngFor="let device of devices"
              mat-menu-item>
        <p>{{ device.deviceName}}</p>
      </button>
    </mat-menu>
  </div>

  <mat-divider></mat-divider>
  <p><b>Opérations</b></p>

  <div class="operationButtonContainer">
    <div>
      <button mat-raised-button color="accent" (click)="refreshStats()">{{'refresh' | translation}}</button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <router-outlet></router-outlet>

</section>
